import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
export const SearchResultLink = styled(RouterLink)`
  text-decoration: none;
  &:hover {
    background-color: transparent;
  }
`;
